import React from 'react';
import { Card, Empty, Typography } from 'antd';

const { Text } = Typography;

const STEP_NOTES = {
    2: 'Scrape variant URLs via brightdata (milestone M2).',
    3: 'Extract details with LLMs + background removal (milestone M3).',
    4: 'Create assets — meshy.ai / manual / texture-gen (milestone M4).',
    5: 'Compress assets — image / .babylon / .glb (milestone M4).',
    6: 'Confirm metadata + sizes and publish to the catalog (milestone M5).',
};

export function PlaceholderStep({ step }) {
    return (
        <Card>
            <Empty description={<Text type="secondary">{STEP_NOTES[step] || 'Not implemented yet.'}</Text>} />
        </Card>
    );
}
